import { Stack, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';
import { Handshake } from '@icons/completed/Handshake';
import { Box } from '@mui/system';
import { styles } from './Completed.style';
import { DocumentIcon } from '@icons/completed/DocumentIcon';

export default function CompletedComponent() {
	const { EndScreen: Text, OUCF } = useContext(LocalizationContext);
	const theme: any = useTheme();
	const checkNotApprovedSubtitle =
		OUCF.CompletedScreenWithNotApprovedCheck ||
		'The check will be stopped. A branch representative will contact you shortly with further instructions.';
	const checkApprovedSubtitle =
		OUCF.CompletedScreenWithApprovedCheck || 'The check is approved. It will be processed soon.';

	const isCheckValidValue = JSON.parse(sessionStorage.getItem('checkValidation') ?? '{}');
	let isCheckValid = false;
	let isCheckTransaction = false;

	if (typeof isCheckValidValue === 'boolean') {
		isCheckTransaction = true;
		isCheckValid = isCheckValidValue;
	} else if (typeof isCheckValidValue === 'object' && Object.keys(isCheckValidValue).length === 0) {
		isCheckTransaction = false;
	}

	return (
		<Stack
			paddingTop={'64px'}
			tabIndex={1}
			aria-label={`${Text.Title || 'Thank you for your help'} ${
				Text.Subtitle || 'Your answers have been sent. You may close this window now.'
			}`}
			data-cy={'pqCompletedScreen'}
			justifyContent={'center'}
			alignItems={'center'}
			textAlign={'center'}
			spacing={'17px'}>
			<Typography variant={'finalScreenTitle'}>{Text.Title || 'Thank you for your help'}</Typography>
			{isCheckTransaction && (
				<Typography variant={'finalScreenSubtitle'}>
					{isCheckValid
						? Text.ApprovedCheckSubtitle || checkApprovedSubtitle
						: Text.NotApprovedCheckSubtitle || checkNotApprovedSubtitle}
				</Typography>
			)}
			{!isCheckTransaction && (
				<Typography variant={'finalScreenSubtitle'}>
					{Text.Subtitle || 'Your answers have been sent. You may close this window now.'}
				</Typography>
			)}

			<Box sx={styles.handshake}>
				{isCheckTransaction && !isCheckValid ? (
					<DocumentIcon />
				) : (
					<Handshake
						primaryColor={theme.palette.primary.main}
						secondaryColor={theme.palette.secondary.main}
					/>
				)}
			</Box>
		</Stack>
	);
}
